<!--
 * @Description: 侧边栏菜单
 * @Autor: lwq
 * @Date: 2020-07-24 18:28:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-14 11:24:24
 * @FilePath: \mrc-base-server-view\src\LAYOUT\sideCompany.vue
-->
<template>
  <v-list dense
          class="layout-drawer">
    <template v-for="(item, index) in list">
      <v-list-item :key="index"
                   style="height:56px;"
                   v-if="
          (item.menus_tree && item.menus_tree.length <= 0) || !item.menus_tree
        "
                   class="listItem"
                   event="getFunctionUuid"
                   @click="getFunctionUuid(item)"
                   :class="{
          listItemBorder: isChild,
          'v-list-item--active':
            '/' + $router.match($route.fullPath).fullPath.split('/')[1] ==
            item.url,
        }">
        <v-list-item-content :style="{ marginLeft: depth * 15 + 'px' }"
                             class="pa-0">
          <v-list-item-title class="menuName pa-0 py-1">
            <span style="word-break:keep-all;word-wrap:break-word;width:169px;white-space:normal;">
              {{ INT(item.menu_name) }}
            </span>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group :key="item.uuid"
                    class="listItemBorder pa-0"
                    v-else>
        <template v-slot:activator>
          <v-list-item-title class="menuName pa-0  d-flex align-center"
                             style="word-break:keep-all; font-weight: normal;height:56px;word-wrap:break-word;width:169px;white-space:normal;">
            {{ INT(item.menu_name) }}
            <!-- <div style="word-wrap:break-word;word-break:break-all;width:169px;white-space:normal;">
              {{ INT(item.menu_name) }}
            </div> -->
          </v-list-item-title>
        </template>

        <side-company :list="item.menus_tree"
                      :isChild="false"
                      :depth="depth + 1" />
      </v-list-group>
    </template>
  </v-list>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'sideCompany',
  components: {},
  props: {
    list: {
      type: Array,
    },
    isChild: {
      type: Boolean,
      default: true,
    },
    depth: {
      type: [String, Number],
      default: 0,
    },
  },
  data () {
    return {}
  },
  validations: {},
  computed: {},
  created () { },
  watch: {},
  mounted () { },
  beforeRouteUpdate () { },
  methods: {
    // 保存菜单功能的uuid
    getFunctionUuid (item) {
      this.$store.commit('setMenuFunctionUuid', item.function_uuid)
      // this.getBtnPermissionList()
      this.$router.push(item.url)
    },
  },
}
</script>

<style scoped>
.listItemBorder {
  border-bottom: 1px solid #dedede;
  /* padding-top: 5px; */
  /* padding-bottom: 5px; */
}
.layout-drawer .menuName {
  font-size: 15.5px;
  overflow: scroll;
}
.v-list-item--link:before {
  background-color: #fff;
}
.v-list-item--active {
  background-color: #fff !important;
  color: #0f46c1;
}
.layout-drawer {
  padding-bottom: 0px;
  padding-top: 0px;
}
.layout-drawer__icon {
  margin-bottom: 8px;
  margin-top: 8px;
}
.layout-drawer
  /deep/
  .v-list-item--active
  .v-list-item__content
  .v-list-item__title {
  font-weight: 600;
  /* font-size: 15px; */
}
.layout-drawer /deep/ .v-list-item__title {
  font-size: 14px;
}
.layout-drawer /deep/ .listItem.v-list-item--active::before {
  top: 50%;
  right: 0;
  width: 4px;
  height: 20px;
  transform: translateY(-50%);
  background-color: #083998;
  opacity: 1;
  transition: none;
}
.layout-drawer /deep/ .theme--light .v-list-item--active:focus::before {
  opacity: 1;
  transition: none;
}
.layout-drawer /deep/ .v-list-item--link:before {
  left: initial;
}
.layout-drawer /deep/ .mdi-chevron-down::before {
  font-size: 16px !important;
}
.v-list-item:hover {
  /* background-color: ; */
  background-color: #eeeef0;
}
.v-list-item:hover .v-list-item__title {
  /* color: black !important; */
}
.v-list-item--active {
  background-color: var(--main-light-color) !important;
}
.v-list-item--active .v-list-item__content .v-list-item__title {
  font-weight: 500 !important;
}
.v-list-item--active:hover {
  background-color: #eeeef0 !important;
}
/* .v-list-group .v-list-group__header {
  background-color: red !important;
} */
/* /deep/ .v-list-group__header.v-list-item.v-list-item--active {
  background-color: var(--main-light-color) !important;
} */
/deep/ .v-list-group__header:hover {
  background-color: #eeeef0 !important;
}
.v-list--dense .v-list-item .v-list-item__title {
  font-weight: 400;
}
/* 兼容ie 隐藏滚动条 */
/* .v-list-item__title {
  overflow: hidden !important;
} */
</style>
